module.exports = __webpack_public_path__ + "Images/layout_black.png";


//////////////////
// WEBPACK FOOTER
// ./Images/layout_black.png
// module id = 810
// module chunks = 2